<template>
    <v-layout justify-center>
        <v-responsive max-width="720" width="100%">
            <list-heading title="채팅상담 안내문구 설정" />

            <v-data-table v-bind="{ loading, headers, items }" item-key="_id" :items-per-page="-1" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" style="overflow: hidden" ref="data-table">
                <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" v-html="header.formatter.bind(item)(value)" /> </template>

                <template #[`item.title`]="{ value, item }">
                    <v-row align="center">
                        <v-col>
                            <span> {{ value }} </span>
                        </v-col>
                        <v-col cols="auto">
                            <v-tooltip right nudge-right="23" transition="fade-transition">
                                <template #activator="{ attrs, on }">
                                    <v-icon small color="info lighten-4" v-bind="attrs" v-on="on">mdi-information-slab-circle</v-icon>
                                </template>
                                <div style="white-space: pre-line">
                                    {{ item.desc }}
                                </div>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </template>
                <template #[`item.text`]="{ item, index }">
                    <v-textarea
                        v-model="items[index].text"
                        v-bind="{
                            ...attrs_input__verticalTable,

                            placeholder: item.placeholder,
                        }"
                        rows="1"
                        auto-grow
                        clearable
                        class="vertical-table-input text-caption"
                    />
                </template>

                <template #footer>
                    <v-divider />
                    <v-row no-gutters>
                        <v-spacer />
                        <v-divider vertical />
                        <v-btn text tile color="primary" height="48" v-bind="{ loading }" @click="update">
                            <v-icon small class="mr-1"> mdi-content-save </v-icon>
                            저장하기
                        </v-btn>
                    </v-row>
                </template>
            </v-data-table>

            <v-fade-transition>
                <v-overlay v-show="loading" light color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import { attrs_input__verticalTable } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";

export default {
    components: {
        ListHeading,
    },
    data: () => ({
        items: [],

        loading: false,

        attrs_input__verticalTable,
    }),
    computed: {
        ...mapGetters("common/setting", ["chatPromptAlerts"]),
        headers() {
            return [
                {
                    text: "분류",
                    value: "title",
                    width: 160,
                },
                {
                    text: "내용",
                    value: "text",
                    cellClass: "pa-0",
                },
            ].map((item, index, array) => ({
                ...item,
                divider: index != array.length - 1,
                cellClass: item.cellClass + ` caption`,
                formatter: item.formatter ?? ((value) => value ?? "-"),
            }));
        },
    },
    methods: {
        ...mapActions("common/setting", ["getData"]),

        async init() {
            this.items = [];
            this.loading = false;

            this.search();
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                await this.getData({ isConsole: true });
                this.items = [...this.chatPromptAlerts];
            } finally {
                this.loading = false;
            }
        },

        async update() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { items: chatPromptAlerts } = this;
                await api.console.setting.put({ chatPromptAlerts });
            } finally {
                this.loading = false;
                this.search();
            }
        },
    },
    mounted() {
        this.init();
    },
};
</script>


<style lang="scss" scoped>
.vertical-table-input ::v-deep .v-input__slot {
    background: transparent !important;
    padding: 0px 16px !important;
}
</style>